import React, { useEffect, useMemo, useState } from "react";
import { useParams, Navigate, useLocation } from "react-router-dom";
import { CITIES_DATA } from "../../data/citiesData";
import MapAndCards from "../common/MapAndCards";
import Header from "../common/Header";
import Services from "../common/Services";
import { useTheme } from "../../contexts/ThemeContext";
import ContactDrawer from "../common/ContactDrawer";
import MapAndCardsHomeCare from "../common/MapAndCardsHomeCare";
import VideoCity from "../conversionLayout/Videocity";

//import imagens
import airMini from "../../img/respiratorios/Catalogo/AirMini.jpg";
import airSense from "../../img/respiratorios/Catalogo/AirSense11.jpg";
import airSense10 from "../../img/respiratorios/Catalogo/AirSenseS10.jpg";
import DreamStation from "../../img/respiratorios/Catalogo/DreamStation.jpg";
import Eclipse5 from "../../img/respiratorios/Catalogo/Eclipse5.jpg";
import Everflo from "../../img/respiratorios/Catalogo/Everflo.jpg";
import FreestyleComfort from "../../img/respiratorios/Catalogo/FreestyleComfort.jpg";
import G2 from "../../img/respiratorios/Catalogo/G2.jpg";
import G2S from "../../img/respiratorios/Catalogo/G2S.jpg";
import G3 from "../../img/respiratorios/Catalogo/G3.jpg"
import Hypnus from "../../img/respiratorios/Catalogo/Hypnus.jpg";
import KitManutencao from "../../img/respiratorios/Catalogo/KitManutenção.jpg";
import M1Mini from "../../img/respiratorios/Catalogo/M1Mini.jpg";
import Rouve6 from "../../img/respiratorios/Catalogo/Rove6.jpg";
import SimplyGo from "../../img/respiratorios/Catalogo/SimplyGo.jpg";
import SleepLive12Pro from "../../img/respiratorios/Catalogo/SleepLive12pro.jpg"
import SleepLiveLT from "../../img/respiratorios/Catalogo/SleepLiveLT.jpg"
import YH480 from "../../img/respiratorios/Catalogo/YH480.jpg"

import img1 from "../../img/mediaCards/1.jpg";
import img2 from "../../img/mediaCards/2.jpg";
import img3 from "../../img/mediaCards/3.jpg";

import MediaCards from "../MediaCards/mediaCards";
import { formatPhone } from "../common/utils";

// ======================
// Helpers / data
// ======================


const getCarouselItemStyle = (index, activeIndex, total) => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const offset = (index - activeIndex + total) % total;

  if (offset === 0) {
    return {
      transform: isMobile ? "scale-100" : "translate-x-20 scale-110",
      zIndex: 30,
      opacity: "opacity-100",
      filter: "blur-0",
    };
  }

  if (offset === 1 || offset === total - 1) {
    return {
      transform: isMobile
        ? "scale-90"
        : offset === 1
          ? "translate-x-16 scale-75"
          : "-translate-x-16 scale-75",
      zIndex: 20,
      opacity: "opacity-70",
      filter: "blur-sm",
    };
  }

  if (offset === 2 || offset === total - 2) {
    return {
      transform: isMobile
        ? "scale-75"
        : offset === 2
          ? "translate-x-40 scale-50"
          : "-translate-x-40 scale-50",
      zIndex: 10,
      opacity: "opacity-40",
      filter: "blur-lg",
    };
  }

  return {
    transform: "scale-0",
    zIndex: 0,
    opacity: "opacity-0",
    filter: "",
  };
};

const CPAP_PRODUCTS = [
  {
    id: 1,
    img: G2,
    title: "BMC G2",
    displayName: "bmc g2",
    paragraphs: [
      "Trabalhamos com venda e locação do BMC G2, um CPAP automático com recursos modernos para um tratamento mais confortável e eficiente.",
      "O equipamento conta com tecnologia de ajuste automático de pressão, operação silenciosa e interface intuitiva para facilitar o uso diário.",
      "É uma excelente opção para pacientes que buscam praticidade, conforto e acompanhamento terapêutico com mais precisão.",
    ],
  },
  {
    id: 2,
    img: G3,
    title: "BMC G3",
    displayName: "bmc g3",
    paragraphs: [
      "O BMC G3 oferece tecnologia avançada para tratamento respiratório, com ótimo desempenho e conforto durante o uso.",
      "Seu sistema automático de pressão e os relatórios de acompanhamento ajudam no monitoramento da terapia.",
      "É indicado para quem busca uma solução moderna, eficiente e com excelente adaptação.",
    ],
  },
  {
    id: 3,
    img: M1Mini,
    title: "M1 Mini",
    displayName: "m1 mini",
    paragraphs: [
      "O M1 Mini é um CPAP compacto, ideal para quem precisa de mobilidade sem abrir mão da qualidade do tratamento.",
      "Seu tamanho reduzido facilita o transporte, sendo uma ótima escolha para viagens e rotina dinâmica.",
      "Mesmo portátil, entrega eficiência terapêutica e conforto para o paciente.",
    ],
  },
  {
    id: 4,
    img: DreamStation,
    title: "DreamStation",
    displayName: "dreamstation",
    paragraphs: [
      "A linha DreamStation é referência em conforto e tecnologia para tratamento de apneia do sono.",
      "Oferece operação silenciosa, interface amigável e dados terapêuticos importantes para acompanhamento clínico.",
      "É uma opção confiável para pacientes que buscam qualidade e praticidade.",
    ],
  },
  {
    id: 5,
    img: Eclipse5,
    title: "Eclipse 5",
    displayName: "eclipse 5",
    paragraphs: [
      "O Eclipse 5 é uma solução robusta e eficiente para pacientes que precisam de suporte respiratório com segurança.",
      "Seu desempenho e confiabilidade tornam o equipamento uma escolha importante em diferentes cenários de uso.",
      "É ideal para quem busca tecnologia e estabilidade no tratamento.",
    ],
  },
  {
    id: 6,
    img: Everflo,
    title: "Everflo",
    displayName: "everflo",
    paragraphs: [
      "O EverFlo é reconhecido pela praticidade, durabilidade e eficiência no suporte respiratório.",
      "Seu funcionamento simples e confiável favorece o uso contínuo com mais tranquilidade para o paciente.",
      "É uma solução muito procurada para quem precisa de desempenho com operação descomplicada.",
    ],
  },
  {
    id: 7,
    img: FreestyleComfort,
    title: "Freestyle Comfort",
    displayName: "freestyle comfort",
    paragraphs: [
      "O Freestyle Comfort foi desenvolvido para oferecer mais liberdade e conforto no tratamento respiratório.",
      "Seu design favorece mobilidade e adaptação ao dia a dia, mantendo a qualidade terapêutica.",
      "É indicado para pacientes que valorizam conforto, autonomia e praticidade.",
    ],
  },
];

const BLOCO_1 = [
  {
    id: 1,
    img: G2,
    title: "O Poder da terapia CPAP",
    displayName: "",
    paragraphs: [
      "Anos de pesquisas clínicas trouxeram de excelência a terapia CPAP no tratamento a apneia. Hoje, o tratamento utiliza algoritmos de pressão dinâmica que acompanham seu ritmo biológico, garantindo conforto sem interrupções.",
      "Ao manter as vias aéreas desobstruídas, a terapia reduz drasticamente riscos cardíacos, estabiliza o metabolismo e elimina o cansaço crônico. Tratar a apneia é mais do que dormir; é proteger seu coração, combate a obesidade e recuperar a saúde física e mental para viver plenamente.",
    ],
  },
  {
    id: 2,
    img: DreamStation,
    title: "Máscara: O Elo Fundamental da Adaptação",
    displayName: "Ajuste Perfeito para uma Terapia Eficaz",
    paragraphs: [
      "A máscara é o componente vital para o sucesso da terapia. Mais do que um acessório, ela define o conforto e a vedação correta do fluxo de ar. Por isso, o acompanhamento de um especialista nesta etapa é importantíssimo: ele identifica o modelo ideal para sua anatomia, prevenindo vazamentos e irritações. Com o ajuste profissional, a adaptação torna-se natural, garantindo que os benefícios clínicos do CPAP se transformem em qualidade de vida real e noites restauradoras.",
    ],
  },
  {
    id: 3,
    img: Eclipse5,
    title: "Oxigenoterapia: Precisão e Liberdade",
    displayName: "",
    paragraphs: [
      "A oxigenoterapia é um tratamento vital que exige prescrição médica rigorosa para garantir a dosagem correta de oxigênio. Hoje, o mercado oferece desde concentradores estacionários, ideais para alto fluxo domiciliar, até modelos portáteis e leves, que permitem ao paciente manter sua mobilidade e independência.",
      "A escolha do aparelho depende do estilo de vida e da necessidade clínica. Por isso, a implantação por especialistas é essencial: eles garantem o ajuste técnico ideal entre o equipamento e o paciente, assegurando segurança, conforto e a máxima eficácia terapêutica no dia a dia.",
    ],
  },
  {
    id: 4,
    img: Everflo,
    title: "Oxigenoterapia: Precisão e Liberdade",
    displayName: "",
    paragraphs: [
      "A oxigenoterapia é um tratamento vital que exige prescrição médica rigorosa para garantir a dosagem correta de oxigênio. Hoje, o mercado oferece desde concentradores estacionários, ideais para alto fluxo domiciliar, até modelos portáteis e leves, que permitem ao paciente manter sua mobilidade e independência.",
      "A escolha do aparelho depende do estilo de vida e da necessidade clínica. Por isso, a implantação por especialistas é essencial: eles garantem o ajuste técnico ideal entre o equipamento e o paciente, assegurando segurança, conforto e a máxima eficácia terapêutica no dia a dia.",
    ],
  },
];

const CPAP_HIGHLIGHT_PRODUCTS = [
  {
    id: 1,
    img: airMini,
    title: "ResMed AirMini",
    category: "CPAP Portátil",
    desc: "CPAP portátil ultracompacto da ResMed ideal para viagens, oferecendo terapia eficaz para apneia do sono."
  },
  {
    id: 2,
    img: airSense,
    title: "ResMed AirSense 11",
    category: "Auto CPAP",
    desc: "Auto CPAP avançado com conectividade inteligente e algoritmos automáticos para tratamento da apneia do sono."
  },
  {
    id: 3,
    img: airSense10,
    title: "ResMed AirSense 10",
    category: "Auto CPAP",
    desc: "Equipamento AutoSet com umidificação integrada e funcionamento silencioso para terapia respiratória confortável."
  },
  {
    id: 5,
    img: DreamStation,
    title: "Philips DreamStation",
    category: "CPAP / Auto CPAP",
    desc: "Equipamento moderno e silencioso com tecnologia avançada para tratamento de distúrbios respiratórios do sono."
  },
  {
    id: 6,
    img: Eclipse5,
    title: "CAIRE Eclipse 5",
    category: "Concentrador de Oxigênio Portátil",
    desc: "Concentrador portátil potente com fluxo contínuo e modo pulso para pacientes que precisam de mobilidade."
  },
  {
    id: 7,
    img: Everflo,
    title: "Philips EverFlo",
    category: "Concentrador de Oxigênio",
    desc: "Concentrador estacionário compacto e confiável para oxigenoterapia domiciliar."
  },
  {
    id: 8,
    img: FreestyleComfort,
    title: "CAIRE FreeStyle Comfort",
    category: "Concentrador de Oxigênio Portátil",
    desc: "Concentrador portátil leve e ergonômico com excelente autonomia de bateria."
  },
  {
    id: 9,
    img: G2,
    title: "BMC G2",
    category: "CPAP / Auto CPAP",
    desc: "Equipamento da linha BMC para terapia do sono, com operação prática e foco em conforto respiratório."
  },
  {
    id: 10,
    img: G2S,
    title: "BMC G2S",
    category: "CPAP / Auto CPAP / BiPAP",
    desc: "Linha BMC G2S voltada à terapia do sono, com opções automáticas e recursos avançados de conforto."
  },
  {
    id: 11,
    img: G3,
    title: "BMC G3",
    category: "CPAP / Auto CPAP / BiPAP",
    desc: "Linha BMC G3 com conectividade e recursos avançados para terapia respiratória do sono."
  },
  {
    id: 12,
    img: Hypnus,
    title: "Hypnus CPAP",
    category: "CPAP",
    desc: "Equipamento respiratório confiável e silencioso para tratamento da apneia do sono."
  },
  {
    id: 13,
    img: KitManutencao,
    title: "Kit de Manutenção CPAP",
    category: "Acessórios",
    desc: "Kit com acessórios essenciais para manutenção e higiene dos equipamentos CPAP."
  },
  {
    id: 14,
    img: M1Mini,
    title: "BMC M1 Mini",
    category: "CPAP Portátil",
    desc: "CPAP portátil compacto ideal para uso diário e viagens."
  },
  {
    id: 15,
    img: Rouve6,
    title: "Inogen Rove 6",
    category: "Concentrador de Oxigênio Portátil",
    desc: "Concentrador portátil de última geração com grande autonomia e alto desempenho."
  },
  {
    id: 16,
    img: SimplyGo,
    title: "Philips SimplyGo",
    category: "Concentrador de Oxigênio Portátil",
    desc: "Concentrador portátil robusto com fluxo contínuo e pulso para uso versátil."
  },
  {
    id: 17,
    img: SleepLive12Pro,
    title: "SleepLive 12 Pro",
    category: "Auto CPAP",
    desc: "Auto CPAP moderno com ajuste automático de pressão para tratamento da apneia do sono."
  },
  {
    id: 18,
    img: SleepLiveLT,
    title: "SleepLive LT",
    category: "CPAP",
    desc: "CPAP compacto e silencioso para terapia respiratória contínua."
  },
  {
    id: 19,
    img: YH480,
    title: "Yuwell YH-480",
    category: "Auto CPAP",
    desc: "CPAP automático com conectividade e umidificação integrada para terapia do sono."
  }
];

const MEDIA_ITEMS = [
  {
    id: 1,
    type: "image",
    src: img1,
    title: "Recepção",
    date: "01/08/25",
    info: "Ribeirão Preto",
  },
  {
    id: 2,
    type: "image",
    src: img2,
    title: "Copa",
    date: "01/08/25",
    info: "Ribeirão Preto",
  },
  {
    id: 3,
    type: "image",
    src: img3,
    title: "Aparelho Auditivo",
    date: "01/08/25",
    info: "Ribeirão Preto",
  },
];

// ======================
// Subcomponentes locais
// ======================

function HeroSection({ city }) {
  return (
    <section className="relative w-full h-[800px] flex items-end justify-center px-4 overflow-visible">
      <div
        className="absolute inset-0 hidden lg:block bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${city.bannerDesktop})` }}
      />

      <div
        className="absolute inset-0 hidden md:block lg:hidden bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${city.bannerTablet})` }}
      />

      <div
        className="absolute inset-0 block md:hidden bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${city.bannerMobile})` }}
      />

      <div className="absolute inset-0 bg-black/10" />

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row justify-between bg-[#F9F9F9]/70 backdrop-blur-md px-16 py-2 mb-8 md:px-16 rounded-t-2xl border border-gray-300 border-1 shadow-xl transform translate-y-1/2">
        <div className="flex-1 px-2 text-center md:text-left">
          <p className="font-montserrat font-bold text-[24px] sm:text-[22px] md:text-[33px] text-[#00394F]">
            Unidade {city.name}
          </p>
          <p className="font-bold text-[#00394F] text-[18px] mt-1">
            {city.address}
          </p>
          <p className="text-[#00394F] mt-1 text-[12px]">
            {formatPhone(city.phone)}
          </p>
        </div>

        <p className="hidden md:block text-gray-600 text-sm flex-1 md:mx-4 mt-4 text-[#939393]">
          Aqui em {city.shortName}, oferecemos soluções personalizadas em Home Care,
          Equipamentos Respiratórios e Aparelhos Auditivos.
        </p>
      </div>
    </section>
  );
}

function ArrowDotsCarousel({ items, activeIndex, setActiveIndex }) {
  return (
    <div className="flex items-center justify-center gap-1 mt-8">
      <button
        onClick={() =>
          setActiveIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1))
        }
        className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-[#efefef] shadow-[0_4px_10px_rgba(0,0,0,0.15)] ring-1 ring-white/80 transition hover:scale-105"
      >
        <span className="text-[16px] text-white">←</span>
      </button>

      {items.map((_, index) => (
        <button
          key={index}
          onClick={() => setActiveIndex(index)}
          className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-[#efefef] shadow-[0_4px_10px_rgba(0,0,0,0.15)]"
        >
          <span
            className={`block h-[12px] w-[12px] rounded-full ${activeIndex === index ? "bg-[#00E85F]" : "bg-[#cfcfcf]"
              } shadow-[inset_0_2px_6px_rgba(0,0,0,0.25)]`}
          />
        </button>
      ))}

      <button
        onClick={() => setActiveIndex((prev) => (prev + 1) % items.length)}
        className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-[#efefef] shadow-[0_4px_10px_rgba(0,0,0,0.15)] ring-1 ring-white/80 transition hover:scale-105"
      >
        <span className="text-[16px] text-white">→</span>
      </button>
    </div>
  );
}

function ContactSpecialistButton() {
  return (
    <button className="mt-8 flex items-center justify-between bg-black text-white rounded-full px-2 py-2 min-w-[330px] hover:scale-[1.02] transition">
      <span className="font-montserrat text-[13px] font-medium ps-2">
        entre em contato com um especialista
      </span>

      <div className="flex items-center justify-center w-[36px] h-[36px] rounded-full bg-white text-black">
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="53.605" height="53.605" rx="26.8025" fill="white" />
          <path
            d="M19.4011 12H41.6049V34.2038"
            stroke="black"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M41.605 12L12 41.605"
            stroke="black"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </svg>
      </div>
    </button>
  );
}

function FloatingCarousel({ items, activeIndex, setActiveIndex, align = "start" }) {
  return (
    <div
      className={`flex w-full flex-col items-center ${align === "end" ? "md:justify-self-end" : "md:justify-self-start"
        }`}
    >
      <div
        className="relative w-full max-w-[480px] h-[350px] flex items-center justify-center"
        style={{ perspective: "1000px" }}
      >
        {items.map((slide, index) => {
          const style = getCarouselItemStyle(index, activeIndex, items.length);

          return (
            <div
              key={slide.id ?? index}
              className={`absolute inset-0 flex items-center justify-center transition-all duration-1000 ease-in-out ${style.opacity}`}
              style={{ zIndex: style.zIndex }}
            >
              <div
                className={`transform ${style.transform} ${style.filter} transition-all duration-1000 w-full h-full flex items-center justify-center`}
                style={{ transformStyle: "preserve-3d" }}
              >
                <img
                  src={slide.img}
                  alt={slide.title}
                  className="max-h-full max-w-full object-contain drop-shadow-2xl rounded-[10px]"
                />
              </div>
            </div>
          );
        })}
      </div>

      <ArrowDotsCarousel
        items={items}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
      />

      <ContactSpecialistButton />
    </div>
  );
}

function TextContentBlock({ title, displayName, paragraphs, align = "start" }) {
  return (
    <div
      className={`w-full max-w-full px-4 sm:px-6 md:max-w-lg md:px-0 ${align === "end" ? "md:justify-self-end" : "md:justify-self-start"
        }`}
    >
      <h2 className="text-3xl font-bold text-[#31B463] mb-6 text-center">
        {title}
      </h2>

      <h4 className="text-sm text-[#31B463] mb-6 text-center">
        {displayName} →
      </h4>

      <div className="space-y-4 break-words text-[#939393] leading-relaxed">
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}

function HighlightNewsSlider({ items }) {
  const loopItems = useMemo(() => items.concat(items), [items]);

  return (
    <div className="w-full overflow-hidden relative">
      <div className="flex gap-6 animate-slide-conversion">
        {loopItems.map((product, index) => (
          <div
            key={`${product.id}-${index}`}
            className="flex-shrink-0 w-full max-w-[620px] h-[250px] rounded-[6px] bg-[#f5f5f5] p-[8px] overflow-hidden transition-shadow duration-300 hover:shadow-lg"
          >
            <div className="grid h-full grid-cols-[220px_minmax(0,1fr)] gap-8">
              <div className="h-full overflow-hidden rounded-[6px] bg-[#ececec]">
                <img
                  src={product.img}
                  alt={product.title}
                  className="h-full w-full object-cover"
                />
              </div>

              <div className="flex min-w-0 flex-col justify-start py-1 pr-2">
                <div className="flex items-start justify-between gap-6">
                  <h3 className="max-w-[360px] font-montserrat text-[14px] font-semibold leading-[1.15] text-black mt-6">
                    {product.title}
                  </h3>

                  <button className="flex h-[42px] shrink-0 items-center gap-3 rounded-full bg-black pl-2 pr-1 text-white transition hover:scale-[1.02] mt-6">
                    <span className="font-montserrat text-[13px] leading-none ps-2">
                      Confira
                    </span>

                    <span className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-white text-black">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M7 17L17 7" />
                        <path d="M7 7h10v10" />
                      </svg>
                    </span>
                  </button>
                </div>

                <div className="mt-6 font-montserrat text-[14px] font-normal text-[#9b9b9b]">
                  {product.date || "10 de Maio"} •{" "}
                  {product.category || "Tipo de notícia"}
                </div>

                <p className="mt-3 max-w-[380px] font-montserrat text-[14px] leading-[1.75] text-[#9b9b9b] line-clamp-4">
                  {product.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ======================
// Página
// ======================

export default function Conversion() {
  const { theme } = useTheme();
  const location = useLocation();
  const { id } = useParams();

  const [selectedService, setSelectedService] = useState("cpap");
  const [mainSlide, setMainSlide] = useState(0);

  const cityId = id ? id.toLowerCase() : null;
  const city = CITIES_DATA[cityId];
  const isActive = location.pathname.startsWith(`/city/${id ?? ""}`);

  const activeBloco1 = BLOCO_1[mainSlide] ?? BLOCO_1[0];
  const activeCpapProduct = CPAP_PRODUCTS[mainSlide] ?? CPAP_PRODUCTS[0];

  useEffect(() => {
    if (selectedService !== "cpap") return;

    const interval = setInterval(() => {
      setMainSlide((prev) => (prev + 1) % CPAP_PRODUCTS.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [selectedService]);

  if (!city) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-[#becdd5] md:bg-[#bcced7] lg:bg-[#d3dadc]">
      <Header city={isActive ? city : null} isActive={city} />

      <HeroSection city={city} />

      {theme.context === "" && (
        <Services onSelectService={setSelectedService} />
      )}

      <MediaCards items={MEDIA_ITEMS} />

      {selectedService === "cpap" && (
        <section className="w-full py-24 space-y-28">
          {/* BLOCO 1 */}
          <div className="mx-auto grid w-full max-w-7xl items-center gap-20 md:grid-cols-2">
            <FloatingCarousel
              items={BLOCO_1}
              activeIndex={mainSlide}
              setActiveIndex={setMainSlide}
              align="end"
            />

            <TextContentBlock
              title={activeBloco1.title}
              displayName={activeBloco1.displayName}
              paragraphs={activeBloco1.paragraphs}
              align="start"
            />
          </div>

          {/* BLOCO 2 */}
          <HighlightNewsSlider items={CPAP_HIGHLIGHT_PRODUCTS} />

          {/* BLOCO 3 */}
          <div className="mx-auto grid w-full max-w-7xl items-center gap-20 md:grid-cols-2">
            <TextContentBlock
              title="CPAPS e periféricos"
              displayName={activeCpapProduct.displayName}
              paragraphs={activeCpapProduct.paragraphs}
              align="end"
            />

            <FloatingCarousel
              items={CPAP_PRODUCTS}
              activeIndex={mainSlide}
              setActiveIndex={setMainSlide}
              align="start"
            />
          </div>

          {/* BLOCO 4 */}
          <HighlightNewsSlider items={CPAP_HIGHLIGHT_PRODUCTS} />

          {/* BLOCO 5 */}
          <div className="mx-auto grid w-full max-w-7xl items-center gap-20 md:grid-cols-2">
            <FloatingCarousel
              items={CPAP_PRODUCTS}
              activeIndex={mainSlide}
              setActiveIndex={setMainSlide}
              align="end"
            />

            <TextContentBlock
              title="CPAPS e periféricos"
              displayName={activeCpapProduct.displayName}
              paragraphs={activeCpapProduct.paragraphs}
              align="start"
            />
          </div>
        </section>
      )}

      {theme.context === "" && <VideoCity />}

      {theme.context === "homecare" ? <MapAndCardsHomeCare /> : <MapAndCards />}

      <ContactDrawer message="Vim do site" city={city} />
    </div>
  );
}
